import { ThemeOptions } from '@mui/material';

import { grey } from '../colors';

export const cardThemeOptions: ThemeOptions = {
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '32px',
          backgroundColor: 'common.white',
          border: `1px solid ${grey[100]}`,
          borderRadius: '4px',
        },
      },
    },
  },
};
